'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataSelector = function () {
  function DataSelector(selector) {
    (0, _classCallCheck3.default)(this, DataSelector);

    this._selector = selector;
  }

  /**
   * @desc wrap value in brackets
   * @returns {String}
   */


  (0, _createClass3.default)(DataSelector, [{
    key: 'bracketed',
    value: function bracketed() {
      return '[' + this._selector + ']';
    }

    /**
     * @desc transform to camelCase
     * @return {String}
     */

  }, {
    key: 'key',
    value: function key() {
      return this._selector.replace(/^data\-/, '').split('-').reduce(function (acc, part, i) {
        if (i) {
          part = part.substring(0, 1).toUpperCase() + part.substring(1);
        }
        return acc + part;
      }, '');
    }

    /**
     * @param {String} value - data attr value
     * @return {String}
     */

  }, {
    key: 'valueEquals',
    value: function valueEquals(value) {
      return '[' + this._selector + '=' + value + ']';
    }

    /**
     * @param {String} value - data attr value
     * @return {String}
     */

  }, {
    key: 'valueContains',
    value: function valueContains(value) {
      return '[' + this._selector + '*=' + value + ']';
    }

    /**
     * @param {String} value - data attr value
     * @return {String}
     */

  }, {
    key: 'valueBeginsWith',
    value: function valueBeginsWith(value) {
      return '[' + this._selector + '^=' + value + ']';
    }

    /**
     * @param {String} value - data attr value
     * @return {String}
     */

  }, {
    key: 'valueEndsWith',
    value: function valueEndsWith(value) {
      return '[' + this._selector + '$=' + value + ']';
    }

    /** @returns {String} */

  }, {
    key: 'toString',
    value: function toString() {
      return this._selector;
    }

    /** 
     * @summary call querySelector
     * @param {Element} [el]
     * @returns {Element|Null}
     */

  }, {
    key: 'node',
    value: function node() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;

      return el.querySelector(this.bracketed());
    }

    /** 
     * @summary call querySelector
     * @param {Element} [el]
     * @returns {Array<Element>}
     */

  }, {
    key: 'nodes',
    value: function nodes() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;

      return [].concat((0, _toConsumableArray3.default)(el.querySelectorAll(this.bracketed()) || []));
    }
  }]);
  return DataSelector;
}();

exports.default = DataSelector;